import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme, { isExpanded }: { isExpanded: boolean }) => ({
    container: {
        maxHeight: isExpanded ? "28rem" : null,
        overflow: "auto",
        padding: "2.25rem 2rem 1.5rem 2rem",

        "&:hover::-webkit-scrollbar-thumb": {
            background: "rgba(0,0,0,.3)",
            borderRadius: "1rem",
            border: "0.125rem solid rgba(0,0,0,.0)",
            backgroundClip: "padding-box",
            padding: "0.125rem",
        },

        "&::-webkit-scrollbar-thumb": {
            background: "rgba(0,0,0,.0)",
        },

        "&::-webkit-scrollbar-track": {
            background: "transparent",
        },

        "&::-webkit-scrollbar": {
            width: "0.5rem",
            background: "transparent",
        },
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: "1.5rem",
        marginBottom: "1.5rem",
        padding: 0,
    },
    footer: {
        display: "flex",
        justifyContent: "center",
    },
    more: {
        color: theme.colors.violet[7],
        height: "2rem",
        width: "10.125rem",
        padding: ".5rem .75rem",

        ".mantine-Button-inner": {
            fontWeight: 500,
        },
    },
}))
